export default __webpack_public_path__ + "static/media/OpenSans-Bold.6e27168f.ttf";